import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconConfig, IconOptions, IconResourceType } from './icon.model';

@Component({
    selector: 'cx-icon',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './icon.component.html',
    standalone: false
})
export class IconComponent {
  type = input<string>();

  protected path = computed(() => {
    const type = this.type();

    return this.getSvgPath(type);
  });

  constructor(private iconConfig: IconConfig) {}

  private getSvgPath(iconType: string): string {
    const svgResource = this.config.resources.find(
      (res) => res.type === IconResourceType.SVG && res.types && res.types.includes(iconType),
    );
    if (svgResource) {
      return svgResource.url ? `${svgResource.url}#${this.getSymbol(iconType)}` : `#${this.getSymbol(iconType)}`;
    }
  }

  private getSymbol(iconType: string) {
    if (this.config && this.config.symbols && this.config.symbols[iconType]) {
      return this.config.symbols[iconType];
    }
  }

  private get config(): IconOptions {
    return this.iconConfig.icon;
  }
}
